import { z } from 'zod';

export const PHONE_MAX_LENGTH = 10;
export const BACKSPACE_KEY_CODE = 8;
export const ENTER_KEY_CODE = 13;

export const MAX_FILE_SIZE = 3 * 1024 * 1024;
export const ACCEPTED_FILE_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]);
export const ERR_MESSAGE = {
  PHONE_INVALID: 'Số điện thoại không đúng định dạng',
  PHONE_EMPTY: 'Vui lòng nhập số điện thoại',
  PHONE_LENGTH: 'Số điện thoại phải có 10 chữ số',
  FULLNAME_EMPTY: 'Vui lòng nhập họ và tên',
  EMAIL_EMPTY: 'Vui lòng nhập email',
  EMAIL_INVALID: 'Định dạng email không đúng',
  FILE_EMPTY: 'Vui lòng tải file',
  FILE_SIZE_TOO_LARGE: 'File kích thước quá lớn',
  FILE_TYPE_NOT_SUPPORT: 'Hỗ trợ định dạng .doc, .docx, .pdf',
  FILE_UPLOAD_FAILED: 'Tải file thất bại'
};
export const submitApplicationSchema = z.object({
  applicantFullname: z.string().nonempty(ERR_MESSAGE.FULLNAME_EMPTY),
  applicantEmail: z
    .string()
    .nonempty(ERR_MESSAGE.EMAIL_EMPTY)
    .email(ERR_MESSAGE.EMAIL_INVALID),
  applicantPhone: z
    .string()
    .nonempty(ERR_MESSAGE.PHONE_EMPTY)
    .length(10, ERR_MESSAGE.PHONE_LENGTH)
    .refine(mobile => /^0(\d{9})$/.test(mobile), {
      message: ERR_MESSAGE.PHONE_INVALID
    }),
  resume: z
    .any()
    .refine(files => files !== null, ERR_MESSAGE.FILE_EMPTY)
    .refine(
      files => files?.size <= MAX_FILE_SIZE,
      ERR_MESSAGE.FILE_SIZE_TOO_LARGE
    )
    .refine(
      files => ACCEPTED_FILE_TYPES.has(files?.type),
      ERR_MESSAGE.FILE_TYPE_NOT_SUPPORT
    ),
  requestPosition: z.string()
});

export type SubmitApplicationInput = z.infer<typeof submitApplicationSchema>;
